module.exports = __webpack_public_path__ + "img/2.78b05939.png";